export default {
  austenite: 'Austenite',
  general: 'General properties',
};
